module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-performers/performance-performers.component.scss
// module id = ./src/app/routes/performance/performance-performers/performance-performers.component.scss
// module chunks = 9